import React, { useState } from 'react';
import { Row, Col, Container, Table, Button, Stack, Form } from 'react-bootstrap';
import { MDBCol, MDBRow, MDBContainer, MDBTableBody, MDBTableHead, MDBTable, MDBBtn } from 'mdb-react-ui-kit';
import data from './records.json';

function Admin() {
  const [dataList, setDataList] = useState(data.posts);
  const [on, setOn] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    age: '',
    group: ''
  });
  const [sortValue, setSortValue] = useState('');
  const sortType = ['id', 'name', 'age', 'group'];

  const clearHandler = (e) => {
    e.preventDefault();
    setOn(false);
    setDataList(data.posts);
  };

  const searchHandler = (e) => {
    e.preventDefault();
    const filteredData = data.posts.filter((item) =>
      item.name.toLowerCase().includes(formData.name.toLowerCase())
    );
    if (filteredData.length === 0) {
      setDataList(['no data found']);
    } else {
      setDataList(filteredData);
      setOn(false);
    }
  };

  const sortHandler = (e) => {
    const value = e.target.value;
    setSortValue(value);
    const sortedData = [...dataList].sort((a, b) => (a[value] > b[value] ? 1 : -1));
    setDataList(sortedData);
    setOn(false);
  };

  const handleChange = (e) => {
    setOn(false);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value
    }));
  };

  const addCredential = (e) => {
    e.preventDefault();
    const newRecord = {
      id: formData.id,
      name: formData.name,
      age: formData.age,
      group: formData.group
    };
    setDataList([...dataList, newRecord]);
    setFormData({
      id: '',
      name: '',
      age: '',
      group: ''
    });
  };

  return (
    <>
      <div>

        <MDBContainer className="shadow lg">
          <MDBRow>
            <form className="text-center mb-3 ml-2" style={{ justifyContent: 'space-between' }}>
              <Stack direction="horizontal" gap={2} className="text-center">
                <input
                  type="search"
                  value={formData.name}
                  name="name"
                  onChange={handleChange}
                  placeholder="Search Name...."
                />
                <Button variant="success" onClick={searchHandler}>
                  Search
                </Button>
                <Button className="primary" onClick={clearHandler}>
                  Clear
                </Button>
                <Button className="Secondary" onClick={() => setOn(true)}>
                  Add
                </Button>
              </Stack>
            </form>
            <MDBCol>
              <MDBTable>
                <MDBTableHead dark>
                  <tr>
                    <th>Sn:no</th>
                    <th>Name</th>
                    <th>Age</th>
                    <th>Group</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody className="align-center mb-0">
                  {dataList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.id}</td>
                        <td>{item.name}</td>
                        <td>{item.age}</td>
                        <td>{item.group}</td>
                      </tr>
                    );
                  })}
                </MDBTableBody>
              </MDBTable>
            </MDBCol>
          </MDBRow>
          <select value={sortValue} onChange={sortHandler} className="mb-3" variant="danger">
            <option>Sorting option</option>
            {sortType.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        </MDBContainer>
      </div>
      {on && (
        <MDBContainer>
          <Form onSubmit={addCredential}>
            <Form.Group className="mb-3">
              <Form.Control type="text" name="id" value={formData.id} onChange={handleChange} placeholder="ID" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control type="text" name="age" value={formData.age} onChange={handleChange} placeholder="Age" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="group"
                value={formData.group}
                onChange={handleChange}
                placeholder="Group"
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              Add
            </Button>
          </Form>
        </MDBContainer>
      )}
    </>
  );
}

export default Admin;
